/**
 * PLA-143: Legacy /record route redirects to V3 upload flow
 * 
 * This page previously used Mux (legacy) upload. Now it redirects to
 * the unified V3 upload flow at /mvp/upload to ensure all upload
 * entry points use the V3 pipeline.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Capture() {
  const navigate = useNavigate();

  // PLA-143: Redirect legacy /record route to V3 upload flow
  useEffect(() => {
    console.log('[PLA-143] Redirecting legacy /record to V3 upload flow (/mvp/upload)');
    navigate('/mvp/upload', { replace: true });
  }, [navigate]);

  // Show nothing while redirecting
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-muted-foreground">Redirecting to upload...</p>
      </div>
    </div>
  );
}